/*
 * @Date: 2022-08-29 16:25:26
 * @LastEditors: kinfai
 * @Description: 上传图片
 * @LastEditTime: 2022-08-29 16:33:35
 * @FilePath: \my-app\src\components\UploadImg\index.jsx
 */
import AliIcon from "../AliIcon";
import { message, Upload } from 'antd';

function UploadImg(props) {
    const { Content, handleSuccess } = props

    const params = {
        name: 'file',
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
                handleSuccess(info)
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        showUploadList: false
    };

    return <Upload {...params}>
        <Content />
    </Upload>
}

UploadImg.defaultProps = {
    Content: () => <AliIcon
        type="icon-weixiao"
        size="20px" color="#A4ADB3"
        style={{ marginRight: "6px", display: "inline-block" }}
    ></AliIcon>,
    handleSuccess: (fileInfo) => { }
}

export default UploadImg;